module.exports = __webpack_public_path__ + "static/media/craig.ddfdf171.png";